<template>
  <el-dialog title="检测"
             :visible.sync="showModal"
             @close="handleCancel"
             width="40%">
    <el-tabs v-model="activeName">
      <el-tab-pane label="检测"
                   name="1">
        <el-card shadow="never">
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>设备编号：{{actData.info.sn}}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>设备名称：{{actData.info.name}}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>电量状态：{{Number(actData.info.electricity)==100?"电量充足":"电量不足"}}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>门开关状态：{{Number(actData.info.door_open)==0?"关":"开"}}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>所属区域：{{actData.info.area_name}}</p>
          <!-- <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>
            低功耗休眠：{{ actData.lora[0] ? (actData.lora[0].FB_LowPowerSleep === '1' ? '是' : '否') : ''}}</p> -->
        </el-card>
      </el-tab-pane>
    </el-tabs>
    <span slot="footer"
          class="dialog-footer">
      <el-button type="primary"
                 @click="handleCancel">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: String
    }
  },
  data() {
    return {
      showModal: this.isShow,
      activeName: '1',
      actData: {
        info: {
          area_name: '',
          door_open: '',
          electricity: '',
          name: '',
          sn: ''
        }
      }
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      fetch.getStatLock({ sn: this.data }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.actData.info = data
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    handleCancel() {
      this.$emit('handleClose')
    }
  }
}
</script>

<style></style>
